import UpgradeYourAdventures from './UpgradeYourAdventures';

export default UpgradeYourAdventures;
